import type { Messages } from '../i18n/messages';

export const queryMessages: Messages = {
  'query.page.title': { en: 'Query', fun: 'Interrogation Room' },
  'query.page.description': {
    en: 'Search platform data. Pick a tab to choose what you are querying.',
    fun: 'Ask the platform awkward questions. Pick a tab to choose your victim.',
  },
  // "Kafka" is a product name — identical en/fun.
  'query.tab.kafka': { en: 'Kafka', fun: 'Kafka' },

  'query.kafka.env.label': { en: 'Environment', fun: 'Environment' },
  'query.kafka.topic.label': { en: 'Topic', fun: 'Topic' },
  'query.kafka.topic.placeholder': { en: 'Search topics', fun: 'Hunt for a topic' },
  'query.kafka.window.label': { en: 'Window', fun: 'How far back' },
  'query.kafka.window.900000': { en: 'Last 15 minutes', fun: 'Last 15 minutes' },
  'query.kafka.window.3600000': { en: 'Last hour', fun: 'Last hour' },
  'query.kafka.window.21600000': { en: 'Last 6 hours', fun: 'Last 6 hours' },
  'query.kafka.window.86400000': { en: 'Last 24 hours', fun: 'Last 24 hours' },
  'query.kafka.run': { en: 'Run', fun: 'Go fetch' },
  'query.kafka.runHint': { en: 'Run the query', fun: 'Run the query' },

  'query.kafka.filter.add': { en: 'Add filter', fun: 'Add filter' },
  'query.kafka.filter.remove': { en: 'Remove filter', fun: 'Remove filter' },
  'query.kafka.filter.pathLabel': { en: 'Field', fun: 'Field' },
  'query.kafka.filter.pathPlaceholder': {
    en: 'e.g. payload.order.id',
    fun: 'e.g. payload.order.id',
  },
  'query.kafka.filter.opLabel': { en: 'Operator', fun: 'Operator' },
  'query.kafka.filter.valueLabel': { en: 'Value', fun: 'Value' },
  'query.kafka.filter.valuePlaceholder': { en: 'Value to match', fun: 'Value to match' },

  'query.kafka.operator.eq': { en: 'equals', fun: 'equals' },
  'query.kafka.operator.neq': { en: 'not equals', fun: 'not equals' },
  'query.kafka.operator.contains': { en: 'contains', fun: 'contains' },
  'query.kafka.operator.exists': { en: 'exists', fun: 'exists' },

  'query.kafka.column.position': { en: 'Partition / offset', fun: 'Partition / offset' },
  'query.kafka.column.time': { en: 'Produced', fun: 'Produced' },
  'query.kafka.column.key': { en: 'Key', fun: 'Key' },
  'query.kafka.column.consumers': { en: 'Consumers', fun: 'Who got it' },
  'query.kafka.column.expand': { en: 'Expand row', fun: 'Expand row' },
  'query.kafka.noConsumers': {
    en: 'No consumer group on this topic',
    fun: 'Nobody is listening',
  },

  'query.kafka.detail.key': { en: 'Key', fun: 'Key' },
  'query.kafka.detail.position': { en: 'Position', fun: 'Position' },
  'query.kafka.detail.produced': { en: 'Produced', fun: 'Produced' },
  'query.kafka.detail.headers': { en: 'Headers', fun: 'Headers' },
  'query.kafka.detail.noHeaders': { en: 'None', fun: 'Nada' },
  'query.kafka.detail.copyKey': { en: 'Copy key', fun: 'Copy key' },
  'query.kafka.detail.mode.parsed': { en: 'Parsed', fun: 'Parsed' },
  'query.kafka.detail.mode.raw': { en: 'Raw', fun: 'Raw' },

  'query.kafka.consumer.consumed': {
    en: 'consumed · {count} ahead',
    fun: 'devoured · {count} ahead',
  },
  'query.kafka.consumer.pending': {
    en: 'pending · {count} behind',
    fun: 'still queueing · {count} behind',
  },
  'query.kafka.consumer.unknown': {
    en: 'no committed offset',
    fun: 'no committed offset',
  },

  'query.kafka.scan.summary': {
    en: 'Scanned {messages} messages across {partitions} partitions, back to {since}.',
    fun: 'Rummaged through {messages} messages across {partitions} partitions, back to {since}.',
  },
  'query.kafka.scan.truncated.cap': {
    en: 'Stopped at the scan limit.',
    fun: 'Stopped at the scan limit.',
  },
  'query.kafka.scan.truncated.deadline': {
    en: 'Stopped at the time limit.',
    fun: 'Ran out of patience.',
  },
  'query.kafka.scan.truncated.limit': {
    en: 'Stopped after the maximum number of matches.',
    fun: 'Stopped after the maximum number of matches.',
  },

  'query.kafka.empty.title': {
    en: 'No match in the scanned window',
    fun: 'Nothing in the scanned window',
  },
  'query.kafka.empty.description': {
    en: 'The message may be older than the window. Widen it and run again.',
    fun: 'It may be older than the window. Widen it and try again.',
  },
  'query.kafka.empty.widen': { en: 'Widen to 24 hours', fun: 'Widen to 24 hours' },
  'query.kafka.start.title': { en: 'Ready when you are', fun: 'Ready when you are' },
  'query.kafka.start.description': {
    en: 'Pick a topic, add any field filters, then run the query.',
    fun: 'Pick a topic, add any field filters, then set it loose.',
  },
  'query.kafka.error.title': { en: 'Query failed', fun: 'Query face-planted' },
  'query.kafka.running': { en: 'Scanning…', fun: 'Rummaging…' },
  'query.kafka.topicLink': { en: 'Open {topic} in Kafka UI', fun: 'Open {topic} in Kafka UI' },
};
